import GenderModal from './GenderModal';

export default GenderModal;
